import { __awaiter } from "tslib";
import { ControlOrderService } from "@/services/models/schedule/controlOrder";
const moduleControlOrder = {
    namespaced: true,
    state: {
        controlOrders: {
            data: [],
            total: 0,
            per_page: 0,
            current_page: 1,
        },
        filter: {
            rut: null,
            mother_rut: null,
            passport: null,
            provisional_rut: null,
            other_identification: null,
            service_node_id: null,
            unity_node_id: null,
            schedule_id: null,
            node_id: null,
            has_citation: null,
            without_citation: null,
            location_id: null,
            state: null,
            professional_id: null,
            start_date: null,
            end_date: null,
        },
        loading: false,
    },
    getters: {
        getControlOrders(state) {
            return state.controlOrders;
        },
        getFilter(state) {
            return state.filter;
        },
        getLoading(state) {
            return state.loading;
        },
    },
    mutations: {
        setControlOrders(state, controlOrders) {
            state.controlOrders = controlOrders;
        },
        setFilter(state, filter) {
            state.filter.rut = filter.rut;
            state.filter.mother_rut = filter.mother_rut;
            state.filter.passport = filter.passport;
            state.filter.provisional_rut = filter.provisional_rut;
            state.filter.other_identification = filter.other_identification;
            state.filter.service_node_id = filter.service_node_id;
            state.filter.unity_node_id = filter.unity_node_id;
            state.filter.schedule_id = filter.schedule_id;
            state.filter.node_id = filter.node_id;
            state.filter.has_citation = filter.has_citation;
            state.filter.without_citation = filter.without_citation;
            state.filter.location_id = filter.location_id;
            state.filter.state = filter.state;
            state.filter.professional_id = filter.professional_id;
            state.filter.start_date = filter.start_date;
            state.filter.end_date = filter.end_date;
        },
        setPageControlOrders(state, page) {
            state.controlOrders.current_page = page;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
    },
    actions: {
        getControlOrders({ commit, state }) {
            return __awaiter(this, void 0, void 0, function* () {
                commit("setLoading", true);
                // commit("setControlOrders", []);
                const CONTROL_ORDERS = yield ControlOrderService.filter(state.filter, state.controlOrders.current_page);
                commit("setControlOrders", CONTROL_ORDERS);
                commit("setLoading", false);
            });
        },
    },
};
export default moduleControlOrder;
